// src/components/ActivityLinkRedirectGate.jsx
// Cuando el link de una actividad (por ejemplo, el que llega en el correo
// post-entrenamiento) se abre en un celular, este componente ofrece pasar
// directo a la app (app.tzone.run) en lugar de forzar a quedarse en la web,
// igual que ya hacemos para el link de invitación en SocialJoinEventPage.
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function ActivityLinkRedirectGate({ children }) {
  const [searchParams] = useSearchParams();
  const activityId = searchParams.get('activityId');
  const date = searchParams.get('date');

  const isMobileDevice =
    typeof navigator !== 'undefined' && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');

  const appUrl = (() => {
    if (!activityId) return null;
    const params = new URLSearchParams();
    params.set('activityId', activityId);
    if (date) params.set('date', date);
    return `https://app.tzone.run/agenda?${params.toString()}`;
  })();

  const shouldOfferRedirect = Boolean(appUrl) && isMobileDevice;

  const [autoRedirectCancelled, setAutoRedirectCancelled] = useState(false);
  const [autoRedirectSecondsLeft, setAutoRedirectSecondsLeft] = useState(4);

  useEffect(() => {
    if (!shouldOfferRedirect || autoRedirectCancelled) return undefined;

    setAutoRedirectSecondsLeft(4);
    const tick = setInterval(() => {
      setAutoRedirectSecondsLeft((prev) => (prev > 0 ? prev - 1 : prev));
    }, 1000);
    const redirectTimer = setTimeout(() => {
      window.location.href = appUrl;
    }, 4000);

    return () => {
      clearInterval(tick);
      clearTimeout(redirectTimer);
    };
  }, [shouldOfferRedirect, autoRedirectCancelled, appUrl]);

  return (
    <>
      {shouldOfferRedirect && !autoRedirectCancelled && (
        <div
          style={{
            margin: '10px auto',
            maxWidth: 720,
            padding: '10px 14px',
            borderRadius: 10,
            background: 'rgba(250, 204, 21, 0.18)',
            color: '#111827',
            fontSize: 13,
          }}
        >
          Te vamos a llevar a la app de Tzone en {autoRedirectSecondsLeft} segundos…{' '}
          <button
            type="button"
            onClick={() => setAutoRedirectCancelled(true)}
            style={{
              background: 'none',
              border: 'none',
              color: '#2563eb',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: 0,
              fontSize: 13,
            }}
          >
            Quedarme viendo esto en la web
          </button>
          {' · '}
          <button
            type="button"
            onClick={() => {
              window.location.href = appUrl;
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#2563eb',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: 0,
              fontSize: 13,
            }}
          >
            Abrir ahora
          </button>
        </div>
      )}
      {children}
    </>
  );
}
